import React from "react";
import ContentCard from "../../../../UI/ContentCard/ContentCard";

import pattern1Img from "../../../../assests/images/pattern1.png";
import pattern2Img from "../../../../assests/images/pattern2.png";
import pattern3Img from "../../../../assests/images/pattern3.png";

const Pattern = () => (
  <ContentCard
    title="THE PATTERN"
    id="pattern"
    image={pattern3Img}
    imageTtitle="Our Pattern"
    frontText="Together with our pattern maker Sascha, who is based in Berlin,
                  we designed the pattern for our first hoodie."
    backTextOne="Together with our pattern maker Sascha, who is based in Berlin, we designed the pattern for our first hoodie. While we were developing
        the pattern we did not only look at design but also at the fit. For us this is important, because we aim to offer products that promise a
        100 % perfect fit to the individual body. We came up with a very unique size formula and grading system to make sure that our products will deliver
        the best fit on the market. For our goal to achieve the perfect fit we also will need the help of the SAMPELL community. We hit the market with a
        totally new size system which has never been tested before.  Therefore we give the promise that we do our best that your ordered product fits your
        body perfectly. If the delivered product for whatever reason does not fit your body, we will either adjust your garment or deliver a new garment. "
    imageBack1={pattern1Img}
    imageTitle1="Print on Paper"
    imageBack2={pattern2Img}
    imageTitle2="Cutting the Fabrics"
    imageBack3={pattern3Img}
    imageTitle3="Sewing"
    caption="Here you see pictures of our first steps to bring our pattern to life"
  />
);

export default Pattern;



// WEBPACK FOOTER //
// ./src/components/Pages/Progress/Content/Pattern.js